import _styled from"styled-components";export const TextItem=_styled.div.withConfig({displayName:"styles__TextItem",componentId:"sc-ef79vk-0"})([""]);